import RecentlyViewedCarousel, { RecentlyViewedCarouselProps } from './RecentlyViewedCarousel'
import RecentlyViewedCarouselContainer from './RecentlyViewedCarouselContainer'

export { RecentlyViewedCarousel, type RecentlyViewedCarouselProps }
export default RecentlyViewedCarouselContainer
